

























































































































































































































































































































































































































































































































































































import Vue from 'vue';
import API from '@/api/common';
import * as models from '@/class/models/views/contact';
import SendErrorModal from './SendErrorModal.vue';
import SERVICE, { metaInfo } from '.';
import { TRIAL_PERIOD_MONTH } from '@/class/common/util/trial';

// SmartSlider3 script tag id
const idPrefix = 'lp_ss3tag_';

export default Vue.extend({
  name: 'Introduction',
  metaInfo: metaInfo({
    title: 'サービス紹介資料ダウンロード ｜ RemoLabo ｜ リモートワーク・テレワークの勤怠管理ツール',
    meta: [
      { name: 'description', content: 'リモートワーク・テレワークの勤怠管理ツール「RemoLabo（リモラボ）」サービス紹介資料ダウンロードのページです。資料では基本的な機能はもちろん、導入の流れや費用まで詳しく解説しています。サービス導入を検討されている方はぜひご覧ください。' },
      { property: 'og:title', content: 'サービス紹介資料ダウンロード - RemoLabo' },
      { property: 'og:url', content: 'https://remolabo.net/service/introduction/' },
    ],
    link: [
      { rel: 'canonical', href: '/service/introduction' },
    ],
  }),
  components: {
    SendErrorModal,
  },
  computed: {
    TRIAL_PERIOD_MONTH() { return TRIAL_PERIOD_MONTH; },
  },
  data() {
    return {
      service: new SERVICE(),
      // header
      activeSpMenu: false,
      // form
      isSendError: false,
      mail: '',
      company: '',
      name: '',
      tel: '',
      employees: '',
      content: '',
      privacyCheck: false,
      errorMail: '',
      errorCompany: '',
      errorName: '',
      errorTel: '',
      errorEmployees: '',
      errorContent: '',
    };
  },
  mounted() {
    this.service.mountedProcess();

    // Smart Slider3
    let idNum = 1;
    const FIRST = `(function(){this._N2=this._N2||{_r:[],_d:[],r:function(){this._r.push(arguments)},d:function(){this._d.push(arguments)}}}).call(window);!function(a){a.indexOf("Safari")>0&&-1===a.indexOf("Chrome")&&document.documentElement.style.setProperty("--ss-safari-fix-225962","1px")}(navigator.userAgent);`;
    const firstTag = document.createElement('script');
    firstTag.id = `${idPrefix}${idNum++}`;
    firstTag.innerHTML = FIRST;
    document.head.appendChild(firstTag);
    const LOAD_SCRIPTS = [
      'n2.min.js', 'smartslider-frontend.min.js', 'ss-simple.min.js', 'w-arrow-image.min.js', 'w-bullet.min.js',
    ];
    for (const scriptFile of LOAD_SCRIPTS) {
      const scriptTag = document.createElement('script');
      scriptTag.id = `${idPrefix}${idNum++}`;
      scriptTag.src = `/service/plugins/smart-slider-3/${scriptFile}`;
      document.head.appendChild(scriptTag);
    }
    const LAST = `_N2.r('documentReady', function(){ _N2.r(["documentReady","smartslider-frontend","SmartSliderWidgetArrowImage","SmartSliderWidgetBulletTransition","ss-simple"],function(){new _N2.SmartSliderSimple('n2-ss-2', {"admin":false,"background.video.mobile":1,"loadingTime":2000,"alias":{"id":0,"smoothScroll":0,"slideSwitch":0,"scroll":1},"align":"normal","isDelayed":0,"responsive":{"mediaQueries":{"all":false,"desktopportrait":["(min-width: 1200px)"],"tabletportrait":["(orientation: landscape) and (max-width: 1199px) and (min-width: 901px)","(orientation: portrait) and (max-width: 1199px) and (min-width: 701px)"],"mobileportrait":["(orientation: landscape) and (max-width: 900px)","(orientation: portrait) and (max-width: 700px)"]},"base":{"slideOuterWidth":570,"slideOuterHeight":400,"sliderWidth":570,"sliderHeight":400,"slideWidth":570,"slideHeight":400},"hideOn":{"desktopLandscape":false,"desktopPortrait":false,"tabletLandscape":false,"tabletPortrait":false,"mobileLandscape":false,"mobilePortrait":false},"onResizeEnabled":true,"type":"auto","sliderHeightBasedOn":"real","focusUser":1,"focusEdge":"auto","breakpoints":[{"device":"tabletPortrait","type":"max-screen-width","portraitWidth":1199,"landscapeWidth":1199},{"device":"mobilePortrait","type":"max-screen-width","portraitWidth":700,"landscapeWidth":900}],"enabledDevices":{"desktopLandscape":0,"desktopPortrait":1,"tabletLandscape":0,"tabletPortrait":1,"mobileLandscape":0,"mobilePortrait":1},"sizes":{"desktopPortrait":{"width":570,"height":400,"max":3000,"min":570},"tabletPortrait":{"width":570,"height":400,"customHeight":false,"max":1199,"min":570},"mobilePortrait":{"width":320,"height":224,"customHeight":false,"max":900,"min":320}},"overflowHiddenPage":0,"focus":{"offsetTop":"#wpadminbar","offsetBottom":""}},"controls":{"mousewheel":0,"touch":"horizontal","keyboard":1,"blockCarouselInteraction":1},"playWhenVisible":1,"playWhenVisibleAt":0.5,"lazyLoad":0,"lazyLoadNeighbor":0,"blockrightclick":0,"maintainSession":0,"autoplay":{"enabled":0,"start":1,"duration":8000,"autoplayLoop":1,"allowReStart":0,"pause":{"click":1,"mouse":"0","mediaStarted":1},"resume":{"click":0,"mouse":"0","mediaEnded":1,"slidechanged":0},"interval":1,"intervalModifier":"loop","intervalSlide":"current"},"perspective":1500,"layerMode":{"playOnce":0,"playFirstLayer":1,"mode":"skippable","inAnimation":"mainInEnd"},"bgAnimations":0,"mainanimation":{"type":"horizontal","duration":800,"delay":0,"ease":"easeOutQuad","shiftedBackgroundAnimation":0},"carousel":1,"initCallbacks":function(){new _N2.SmartSliderWidgetArrowImage(this);new _N2.SmartSliderWidgetBulletTransition(this, {"area":12,"dotClasses":"n2-style-7eb7e392ecbe6de12e9dcbdafd40d535-dot ","mode":"","action":"click"});}});}); });`;
    const lastTag = document.createElement('script');
    lastTag.id = `${idPrefix}${idNum++}`;
    lastTag.innerHTML = LAST;
    document.head.appendChild(lastTag);
  },
  destroyed() {
    this.service.destroyProcess();

    // Smart Slider3
    for (let i = 1; i < 8; i++) {
      (document.getElementById(`${idPrefix}${i}`) as HTMLInputElement).remove();
    }
  },
  methods: {
    async onSubmit() {
      // 入力チェック
      const noinput = '未入力です。';
      this.errorCompany = this.company ? '' : noinput;
      this.errorName = this.name ? '' : noinput;
      this.errorEmployees = this.employees ? '' : noinput;
      this.errorContent = this.content.length <= 500 ? '' : '500文字以内で入力してください。';
      if (this.mail) {
        if (this.mail.match(/^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
          this.errorMail = '';
        } else {
          this.errorMail = 'メールアドレスの形式ではありません。';
        }
      } else {
        this.errorMail = noinput;
      }
      if (this.tel) {
        if ( this.tel.match(/^\d{2}-\d{4}-\d{4}$/)
          || this.tel.match(/^\d{3}-\d{3,4}-\d{4}$/)
          || this.tel.match(/^\d{4}-\d{2}-\d{4}$/)
          || this.tel.match(/^\d{4}-\d{3}-\d{3}$/)
          || this.tel.match(/^\d{5}-\d{1}-\d{4}$/)
          || this.tel.match(/^\d{10,11}$/)
        ) {
          this.errorTel = '';
        } else {
          this.errorTel = '電話番号の形式ではありません。';
        }
      } else {
        this.errorTel = noinput;
      }
      // 入力エラーが1つでもあれば送信しない
      if (!this.privacyCheck || this.errorMail || this.errorCompany || this.errorName
        || this.errorTel || this.errorEmployees || this.errorContent) {
        return;
      }
      // 送信処理
      const reqData: models.IIntroduction = {
        mail: this.mail,
        company: this.company,
        name: this.name,
        tel: this.tel,
        employees: this.employees,
        content: this.content,
      };
      const api = new API();
      const res = await api.post<models.IIntroduction, {deneid: boolean}>('contact/introduction', reqData);
      if (res.result) {
        const link = document.getElementById('download-document');
        if (link) {
          // PDF表示
          link.click();
        }
      } else {
        this.isSendError = true;
      }
    },
  },
});
